import { useRef } from 'react';
import ChatListEmpty from './ChatListEmpty';
import MyChatCard from './MyChatCard';
import LeftSideListLayout from '../LeftSideListLayout';
import { CapaQuotationUserChatRoom } from '@generated/graphql';
import { LeftSideCommonProps } from './types';
import ChatFilter from './ChatFilter';
import useChatList from './useChatList';
import { Divider } from '@material-ui/core';
import LoadingPresenter from '@components/Loading';

const ChatList = ({
  route,
  selectedChatRoomId,
  onChangeVisible
}: LeftSideCommonProps) => {
  const {
    chatRooms,
    setSearchParam,
    callbackRef,
    refetch,
    fetchLoading
  } = useChatList();
  const container = useRef<HTMLDivElement>(null);
  const isListEmpty = chatRooms.length === 0;

  return (
    <>
      <LoadingPresenter open={fetchLoading} />
      <ChatFilter setSearchParam={setSearchParam} />

      <Divider />

      <LeftSideListLayout route={route} ref={container}>
        {isListEmpty && <ChatListEmpty />}

        {chatRooms.map((room, index) => {
          const isLastItem = index === chatRooms.length - 1;
          return (
            <MyChatCard
              key={room.chatRoomId}
              room={room as CapaQuotationUserChatRoom}
              isOldRfq={room.isOldRfq ?? false}
              isSelected={room.chatRoomId === selectedChatRoomId}
              isLast={isLastItem}
              route={route}
              callbackRef={callbackRef}
              refetch={refetch}
              onChangeVisible={onChangeVisible}
            />
          );
        })}
      </LeftSideListLayout>
    </>
  );
};

export default ChatList;
